import cn from 'clsx'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { FC } from 'react'

interface auxItems {
  linkTitle: string
  link: string
}

interface Props {
  auxItems: auxItems[]
}

const AuxSidebar: FC<Props> = ({ auxItems }) => {
  const { asPath } = useRouter()

  if (auxItems.length === 0) return <></>

  return (
    <div className="">
      <ul className="">
        {auxItems.map((i, index) => {
          return (
            <li
              key={index}
              className={cn('px-4 py-4 text-body1 font-light', {
                'text-body1  text-brand-dark-grey bg-ui-lightest-grey':
                  asPath === i?.link,
              })}
            >
              <Link
                href={i?.link || '/'}
                passHref
                className={cn('text-brand-dark-grey font-medium', {
                  'text-body1 text-brand-dark-grey': asPath === i?.link,
                })}>

                {i?.linkTitle}

              </Link>
            </li>
          );
        })}
      </ul>
      <div className="border-t border-grey block w-full lg:w-76"></div>
    </div>
  );
}

export default AuxSidebar
